export const FALTAR = 'Faltar';
export const PARAR = 'Parar';
export const ESTORNAR = 'Estornar';
export const ALTERAR = 'Alterar';
export const EXCLUIR = 'Excluir';
export const IMPRIMIR = 'Imprimir';
export const PRIORIZAR = 'Priorizar';
export const REMOVER_PRIORIDADE = 'Remover Prioridade';
